// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoFrame__jkP_M {
  width: 100%;
  aspect-ratio: 16 / 9;
  border: 0;
  border-radius: 0.5rem;
  background: #000;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/FirstLoginVideoDialog/firstLoginVideoDialog.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".videoFrame {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border: 0;\n  border-radius: 0.5rem;\n  background: #000;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoFrame": `videoFrame__jkP_M`
};
module.exports = ___CSS_LOADER_EXPORT___;
